import React from 'react';

export default function IntroSection() {
  return (
    <section aria-label="Introdução" className="intro-section">
      <h1>Cálcio corrigido pela albumina: calculadora e limitações</h1>
      <p>
        Use a calculadora para estimar o cálcio ajustado pela albumina em unidades convencionais ou SI.
        O resultado aplica a fórmula tradicional e não substitui a medição do cálcio ionizado nem a avaliação clínica.
      </p>
      <p>
        <strong>Resposta rápida:</strong> cálcio corrigido (mg/dL) = cálcio total + 0,8 × (4,0 − albumina em g/dL).
        A referência típica é de 8,5 a 10,5 mg/dL. Procurando o <a href="#calcio-ionico">cálcio iônico</a>? Ele é medido, não calculado.
      </p>
    </section>
  );
}
